// Entry point for the build script in your package.json
import Alpine from 'alpinejs'
import zxcvbn from 'zxcvbn'

// Import utility modules
import './utils/debounce.js'
import './components/autocomplete.js'
import './components/password_reset.js'
import './components/trouble_signin_dropdown.js'
import './components/passkey_challenge.js'
import './components/passkey_assisted_login.js'
import './components/mobile_approval.js'

window.Alpine = Alpine
window.zxcvbn = zxcvbn

function initFloatingLabels() {
  const inputFields = document.querySelectorAll('.floating-input-container .floating-input');

  if (inputFields.length === 0) {
    return;
  }

  inputFields.forEach(input => {
    function checkContent() {
      // Handle dropdown triggers differently - check textContent instead of value
      if (input.classList.contains('dropdown-trigger')) {
        const dropdownValue = input.querySelector('.dropdown-value');
        if (dropdownValue && dropdownValue.textContent.trim() !== '') {
          input.classList.add('has-content');
        } else {
          input.classList.remove('has-content');
        }
      } else {
        // Regular input fields
        if (input.value.trim() !== '') {
          input.classList.add('has-content');
        } else {
          input.classList.remove('has-content');
        }
      }
    }

    checkContent();
    input.addEventListener('input', checkContent);
    input.addEventListener('blur', checkContent);
  });

  // Simulate interaction to trigger layout recalculation. Without this, the
  // floating label might not position correctly after autofill in Chrome.
  setTimeout(() => {
    document.body.click();
  }, 100);
}

// Make initFloatingLabels available globally for dynamic content
window.initFloatingLabels = initFloatingLabels;

// Initialize on DOM content loaded and when Alpine is ready (for dynamic content)
document.addEventListener('DOMContentLoaded', initFloatingLabels);
document.addEventListener('alpine:initialized', initFloatingLabels);

Alpine.start()
